import { useCallback } from "react";

import { useNavigate } from "react-router-dom";

import { apiClient } from "../../lib/api";

import type { Dispatch, SetStateAction } from "react";
import type { NavigateFunction } from "react-router-dom";

import type { User } from "../../types";

export function useLogout(setUser: Dispatch<SetStateAction<User | null>>): () => Promise<void> {
  const navigate: NavigateFunction = useNavigate();

  const logout = useCallback(async () => {
    try {
      await apiClient.logout();
    } finally {
      setUser(null);

      navigate(`/login`, { replace: true });
    }
  }, [navigate, setUser]);

  return logout;
}
